<script>
    import {page} from '$app/stores';
    import {app_url} from '$lib/svelte_1848_settings.js';
    import Head from '$lib/Head.svelte';
    import HeaderApp from '$lib/header/Header-app.svelte';
</script>

<Head title="{$page.status} | 1848.nl"/>

<HeaderApp/>

<main>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h1>Er is een fout opgetreden</h1>
                <p>Ga terug naar de <a href="{app_url}app">homepage</a>, of neem contact op met <a href="mailto:info@1848.nl">info@1848.nl</a>.</p>
                <p>Foutmelding: {$page.status}, {$page.error.message}</p>
            </div>
        </div>
    </div>
</main>

<style lang="scss">
    main {
        background-color: var(--light-blue-color);
        padding-top: 26px;
        padding-bottom: 53px;
    }
</style>
